<template>
    <div
        v-if="contactWeather.iconUrl"
        class="weather"
    >
        <div class="weather-image">
            <img :src="contactWeather.iconUrl" />
        </div>
        <div class="weather-content">
            <div>
                <div> {{ contactWeather.cityName }}{{ isState() }}- {{ dateFormatDate() }} </div>
            </div>
            <div>
                <div> {{ contactWeather.temperature }} - {{ contactWeather.description }} </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        contactId: [String, Number],
        contactState: String,
        contactWeather: Object,
    },

    methods: {
        dateFormatDate() {
            const formattedDate = new Date();

            return moment(formattedDate).format('hh:mm A');
        },

        isState() {
            let state = ' ';

            if (this.contactState !== '' && this.contactState !== null) {
                state = `, ${this.contactState} `;
            }

            return state;
        },
    },
};
</script>

<style lang="scss" scoped>
.weather {
    display: flex;
    margin-top: $spacing-200;
    margin-right: $spacing-200;
    margin-left: auto;
}

.weather-image {
    width: 2rem;
    height: 2rem;
    margin-right: $spacing-200;
}

.weather-content {
    display: flex;
    flex-direction: column;
    color: $color-gray;
    font-size: $font-size-xs;
}
</style>
